import React, { useState, useContext } from 'react';
import styles from './ResultReview.module.css';
import { KickCounterContext } from '../../context/KickCounterContext';
import Time from '../time/Time';
import KickList from '../kick-counter/KickList';
import numberToStrengthString from '../../utils/strength';
import COLORS from '../../constants/colors';

const filterIcon = require('../../assets/icons/filter_icon.svg').default;

export default function ResultReview() {
  const [date] = useState(new Date());
  const { time, kickList, strength } = useContext(KickCounterContext);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <div>
          Session: &nbsp;&nbsp;
          <span className={styles.dateContainer}>{date.toLocaleDateString()}</span>
        </div>
      </div>
      <div className={styles.reviewContainer}>
        <div className={styles.statContainer}>
          <div className={styles.statItem}>
            Total Movements
            <span className={styles.stat}>{kickList.length}</span>
          </div>
          <div className={styles.statItem}>
            Time Elapsed
            <span>
              <Time time={time} />
            </span>
          </div>
          <div className={styles.statItem}>
            Session Strength
            <span>{numberToStrengthString(strength)}</span>
          </div>
        </div>
        <div className={styles.kickListContainer}>
          <div className={styles.listTitleContainer}>
            <div className={styles.listTitle}>
              <span>Movement Type</span>
              <img src={filterIcon} alt="" width="13px" />
            </div>
            <div className={styles.listTitle}>
              <span>Time Stamp</span>
              <img src={filterIcon} alt="" width="13px" />
            </div>
            <div />
          </div>
          <KickList backgroundColor={COLORS.backgroundGray} />
        </div>
      </div>
    </div>
  );
}
